import React from "react";

export interface AppMetadata {
  forceAppVersion: string;
  softAppVersion: string;
  isMaintenance: boolean;
  webSpaVersion: number;
  yearInReviewMode: "enabled" | "adminOnly" | "disabled" | "definedCoaches";
  yearInReviewCoachesList?: number[];
}

export const AppMetadataContext = React.createContext<AppMetadata>(null);

export function useAppMetadata() {
  return React.useContext(AppMetadataContext);
}
